/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Link, Typography} from "@mui/material";
import logo from "../Recursos/logo_barra.svg";
import {useNavigate} from "react-router-dom";
import icono_localizacion from '../Recursos/icono_localizacion.svg'
import icono_llamada from '../Recursos/icono_llamada.svg'
import icono_correo from '../Recursos/icono_correo.svg'
import icono_nit from '../Recursos/icono_nit.svg'
import {theme} from "../Tema";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politica from "./Dialogos/Dialogo_Politicas";
import {SECCIONES} from "../Constantes";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {obtenerColWheres} from "../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {marcarEvento} from "../Servicios/Analiticas/marcarEvento";


const contactos = [
    {imagen: icono_localizacion, contacto: 'Carrera 28 A No. 17 - 15 Oficina 202 Edificio Antonella', ruta: '/',},
    {imagen: icono_llamada, contacto: '(602) 73-520-83 / +57 315-540-4983', ruta: '/nosotros',},
    {imagen: icono_correo, contacto: 'secretariasonar@gmail.com', ruta: '/compras',},
    {imagen: icono_nit, contacto: '900849614-1', ruta: '/carrito',}
];


const redes = [];


const Footer = () => {
    const navigate = useNavigate()
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politica})
    const [politicas, setPoliticas] = useState([])

    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({coleccion: 'adicionales', wheres: w}).then((dox) => {
            if (dox.res) {
                setPoliticas(dox.data)
            }
        })
    }, []);
    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}
            sx={{backgroundImage: `linear-gradient(135deg, #000000 70%, #009FDF 140%)`, pt: 10, pb: 6}}>

            <Dialogo/>

            <Grid2
                container
                size={11}
                sx={{maxWidth: '1400px', color: 'white', mx: 2, alignItems: 'center'}}>

                <Grid2 container size={{xs: 12, sm: 6, md: 4}}>
                    <img
                        onClick={() => navigate('/Home')}
                        src={logo} height={'auto'} width={'50%'}
                        style={{cursor: 'pointer',}}
                    />
                </Grid2>

                <Grid2
                    container
                    alignItems={'flex-start'}
                    justifyContent={'flex-end'}
                    size={12}
                    sx={{px: {xs: 2, md: 6}}}
                >

                    <Grid2
                        container
                        alignItems={'flex-start'}
                        justifyContent={'flex-end'}
                        spacing={2}
                        size={{xs: 12, sm: 6, md: 3}}
                        sx={{pt: 10}}>

                        {SECCIONES.map((item) => (
                            <Grid2 container size={12}>
                                <Typography sx={{fontSize: 20}}>
                                    {item}
                                </Typography>
                            </Grid2>

                        ))}

                    </Grid2>

                    <Grid2 container
                           spacing={2}
                           size={{xs: 12, sm: 6, md: 6}} sx={{pt: 10}}>

                        {contactos.map((contacto) => (

                            <Link

                                key={contacto.nombre}
                                disableElevation={true}
                                sx={{
                                    alignItems: 'center',
                                    width: '100%',
                                    color: 'white',
                                    display: 'block',
                                    fontSize: 16,
                                    fontWeight: 800,
                                    cursor: 'pointer',
                                    textDecoration: 'none',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        color: theme.palette.primary.main,
                                    },
                                }}>
                                <Grid2 container size={12}>
                                    <Grid2 container size={1}>
                                        <img
                                            onClick={() => navigate('/Home')}
                                            src={contacto.imagen} width={20} height={'auto'}
                                            style={{cursor: 'pointer'}}
                                        />
                                    </Grid2>


                                    <Grid2 container size={11}
                                           sx={{paddingLeft: 2}}>
                                        <Typography sx={{fontSize: sCell ? 18 : 20}}>
                                            {contacto.contacto}
                                        </Typography>
                                    </Grid2>
                                </Grid2>
                            </Link>
                        ))}
                    </Grid2>

                    <Grid2 container
                           spacing={2}
                           size={{xs: 12, sm: 4, md: 3}} sx={{pt: 10}}>

                        {politicas.map((politica) => (
                            <Grid2 container
                                   onClick={() => {
                                       marcarEvento(politica.nombre)
                                       abrir(politica)
                                   }}
                                   size={12}>


                                <Typography sx={{
                                    color: 'white',
                                    display: 'block',
                                    fontSize: 20,
                                    fontWeight: 400,
                                    cursor: 'pointer',
                                    textDecoration: 'none',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        color: theme.palette.primary.main,
                                    },
                                }}>
                                    {politica.titulo}
                                </Typography>


                            </Grid2>
                        ))}
                        <Grid2 container
                               size={12} sx={{pt: 0}}>
                            {redes.map((red, index) => (
                                <Link key={index} target="_blank" rel="noopener"
                                      onClick={() => {
                                          alert(red.url);
                                      }}
                                      sx={{cursor: 'pointer', pr: 4}}>
                                    <img src={red.imagen} alt={red.alt} width={40}/>
                                </Link>
                            ))}
                        </Grid2>
                    </Grid2>

                </Grid2>

                <Grid2 container size={12}>
                    <Typography sx={{textAlign: 'center', width: '100%', mt: 16}}>
                        © Copyright 2025 - 2026 | Sonar S.A.S
                    </Typography>
                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default Footer

const politicas = [

    {
        nombre: 'Tratamiento de datos personales',
        descripcion: <> <p><strong>POLÍTICAS DE PRIVACIDAD Y TRATAMIENTO DE DATOS</strong></p><p><strong>1.
            Introducción</strong></p><p>La ASOCIACIÓN NACIONAL DE CARGA ASOCARGAN (en adelante "ASOCARGAN") está
            comprometida con la protección de los datos personales de sus usuarios, asociados y colaboradores. Estas
            políticas establecen las condiciones bajo las cuales se recolecta, almacena, usa, circula y protege la
            información personal, de conformidad con la Ley 1581 de 2012 y el Decreto 1377 de 2013.</p><p><strong>2.
            Finalidad del Tratamiento de Datos</strong></p><p>Los datos personales recolectados por ASOCARGAN serán
            utilizados para los siguientes fines:</p>
            <ul>
                <li>Gestionar la relación con los asociados y clientes.</li>
                <li>Cumplir con obligaciones legales y regulatorias.</li>
                <li>Enviar información sobre capacitaciones, eventos y servicios.</li>
                <li>Realizar estudios estadísticos e investigaciones de mercado.</li>
                <li>Responder solicitudes, peticiones, quejas o reclamos.</li>
            </ul>
            <p><strong>3. Derechos de los Titulares de los Datos</strong></p><p>Los titulares de los datos personales
                tienen los siguientes derechos:</p>
            <ul>
                <li>Conocer, actualizar y rectificar su información personal.</li>
                <li>Solicitar prueba de la autorización otorgada para el tratamiento de sus datos.</li>
                <li>Ser informados sobre el uso dado a sus datos.</li>
                <li>Presentar quejas ante la Superintendencia de Industria y Comercio (SIC) por incumplimiento de las
                    normas.
                </li>
                <li>Revocar la autorización y/o solicitar la eliminación de sus datos cuando no exista una obligación
                    legal que impida su supresión.
                </li>
            </ul>
            <p><strong>4. Autorización para el Tratamiento de Datos</strong></p><p>ASOCARGAN solicitará la autorización
                expresa del titular de los datos para su recolección y tratamiento. Esta autorización podrá darse por
                escrito, verbalmente o mediante conductas inequívocas que permitan concluir que el titular consiente el
                tratamiento de su información.</p><p><strong>5. Medidas de Seguridad</strong></p><p>ASOCARGAN implementa
                medidas de seguridad adecuadas para proteger la información personal contra acceso no autorizado, uso
                indebido o pérdida. Solo el personal autorizado podrá acceder a los datos, garantizando su
                confidencialidad.</p><p><strong>6. Transferencia y Transmisión de Datos</strong></p><p>ASOCARGAN podrá
                compartir los datos personales con terceros cuando sea necesario para la prestación de servicios o el
                cumplimiento de obligaciones legales, garantizando la protección adecuada de la información.</p><p>
                <strong>7. Procedimiento para el Ejercicio de Derechos</strong></p><p>Los titulares pueden presentar
                solicitudes, quejas o reclamos relacionados con el tratamiento de sus datos a través del correo
                electrónico [correo@asocargan.com] o en las oficinas de ASOCARGAN. Se atenderán en un plazo máximo de 15
                días hábiles.</p><p><strong>8. Vigencia y Modificaciones</strong></p><p>Esta política entra en vigencia
                a partir de su publicación y podrá ser actualizada o modificada según cambios en la normatividad
                vigente. Cualquier modificación será informada a los titulares a través de los medios de contacto
                registrados.</p></>
    },

    {
        nombre: 'Aviso de privacidad', descripcion:
            <><p><strong>Registro Legal de ASOCARGAN</strong></p><p><br/></p><p>ASOCARGAN está legalmente constituida y
                registrada conforme a la normativa vigente. Nuestro número de inscripcion y nit es <strong> S0002973
                    Nit: 901761536-9 </strong>, garantizando transparencia y cumplimiento con las disposiciones legales.
            </p></>
    },

    {
        nombre: 'Políticas de calidad',
        descripcion:
            <>
                <p><strong>Representante Legal de ASOCARGAN</strong></p><p><br/></p><p>Para garantizar el cumplimiento
                de nuestra misión y la correcta gestión de la asociación, ASOCARGAN cuenta con un representante legal
                debidamente designado.</p><p><br/></p><p><strong>Datos del Representante Legal:</strong></p><p><br/></p>
                <ul>
                    <li><strong>Nombre:</strong> Johanna Elizabeth Delgado Burgos</li>
                    <li><strong>Cédula de Ciudadanía:</strong> 36.751.004</li>
                    <li><strong>Cargo:</strong> Representante Legal de ASOCARGAN</li>
                </ul>
                <p><br/></p>
            </>

        ,
    },
];
